import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormInput, FormButton, Margin, Text } from 'shared/components'

import * as styles from './styles'

const RequestFormComponent = ({ form, onSubmitForm }) => (
  <Form form={form} onSubmit={onSubmitForm}>
    <Margin bottom={1}>
      <FormInput
        name="email"
        label="Email"
        type="email"
        placeholder="account@email.com"
      />
    </Margin>

    <Margin top={2} css={styles.buttonContainer}>
      <FormButton submit size="small">
        <Text size={16} upper bold black>
          Request data deletion
        </Text>
      </FormButton>
    </Margin>
  </Form>
)

RequestFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmitForm: PropTypes.func.isRequired,
}

export default RequestFormComponent
